import * as React from 'react';
import { Backdrop } from '../Backdrop/Backdrop.js';
import { useMergedRefs } from '../../utils/index.js';
import { useDialogContext } from './DialogContext.js';
import cx from 'classnames';
export const DialogBackdrop = React.forwardRef((props, ref) => {
  let dialogContext = useDialogContext();
  let {
    isVisible = dialogContext.isOpen,
    isDismissible = dialogContext.isDismissible,
    onClose = dialogContext.onClose,
    closeOnExternalClick = dialogContext.closeOnExternalClick,
    relativeTo = dialogContext.relativeTo,
    onMouseDown,
    className,
    style,
    ...rest
  } = props;
  let backdropRef = React.useRef(null);
  let refs = useMergedRefs(backdropRef, ref);
  let handleMouseDown = (event) => {
    event.persist();
    if (event.target !== backdropRef.current) return;
    if (isDismissible && closeOnExternalClick && onClose) onClose(event);
    onMouseDown?.(event);
  };
  return React.createElement(Backdrop, {
    isVisible: isVisible,
    className: cx(
      {
        'iui-backdrop-fixed': 'viewport' === relativeTo,
      },
      className,
    ),
    ref: refs,
    onMouseDown: handleMouseDown,
    style: {
      pointerEvents: 'auto',
      ...style,
    },
    ...rest,
  });
});
